import { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import "./navbar.css";
import logo from "../../assets/navbar/logo.svg";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [showNavbar, setShowNavbar] = useState(true);
  const location = useLocation();

  const lastScroll = useRef(0); 

useEffect(() => {
  const getScroll = () => {
    return (
      window.scrollY ||
      document.documentElement.scrollTop ||
      document.body.scrollTop
    );
  };

  const handleScroll = () => {
    const currentScroll = getScroll();

    if (currentScroll > lastScroll.current && currentScroll > 80) {
      setShowNavbar(false);
    } else {
      setShowNavbar(true);
    }

    lastScroll.current = currentScroll;
  };

  window.addEventListener("scroll", handleScroll);

  const elements = document.querySelectorAll("*");

  elements.forEach((el) => {
    el.addEventListener("scroll", handleScroll);
  });

  return () => {
    window.removeEventListener("scroll", handleScroll);
    elements.forEach((el) => {
      el.removeEventListener("scroll", handleScroll);
    });
  };
}, []);

  const menuItems = [
    { name: "INICIO", path: "/" },
    { name: "INTERNET", path: "/internet" },
    { name: "TELEVISIÓN", path: "/television" },
    { name: "DESARROLLO DE SOFTWARE", path: "/software" },
    { name: "TRABAJA CON NOSOTROS", path: "/trabajaconnosotros" },
    { name: "CONTACTO", path: "/contacto" },
  ];

  return (
    <nav className={`navbar ${showNavbar ? "show" : "hide"}`}>
      <div className="navbar-container">

        <div className="navbar-left">
          <Link to="/">
            <img src={logo} alt="Logo" className="brand-logo" />
          </Link>
        </div>

        <div
          className={`menu-toggle ${open ? "active" : ""}`}
          onClick={() => setOpen(!open)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        <ul className={`nav-links ${open ? "open" : ""}`}>
          {menuItems.map((item) => (
            <li
              key={item.name}
              className={location.pathname === item.path ? "active" : ""}
              onClick={() => setOpen(false)}
            >
              <Link to={item.path}>{item.name}</Link>
            </li>
          ))}
        </ul>

      </div>
    </nav>
  );
}